import { AvatarGroup as MuiAvatarGroup } from '@mui/material';
import type { AvatarGroupProps } from './types';
import styled from '@emotion/styled';

export const AvatarGroup = ({
  max,
  children,
  total,
  overlap = 'large',
  renderSurplus,
}: AvatarGroupProps) => {
  return (
    <StyledAvatarGroup
      max={max}
      total={total}
      variant="circular"
      overlap={overlap}
      renderSurplus={renderSurplus}
    >
      {children}
    </StyledAvatarGroup>
  );
};

const spacingMap = {
  large: 22,
  medium: 16,
  small: 8,
};

const StyledAvatarGroup = styled(MuiAvatarGroup, {
  shouldForwardProp: prop => prop !== 'overlap',
})<{
  overlap: 'large' | 'medium' | 'small';
}>`
  && {
    flex-direction: row;
    > div.MuiAvatar-root {
      margin-left: -${({ overlap }) => spacingMap[overlap]}px;
      transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      &.MuiAvatarGroup-avatar {
        margin-right: ${({ overlap }) => spacingMap[overlap] / 2}px;
      }
      :first-child {
        margin-left: 0;
      }
    }
    :hover > div.MuiAvatar-root {
      margin-left: 4px;
    }
  }
`;
